import api from './api';

const fetchApplicationEvents = async (customEvents = false) => {
  try {
    let path = '/application-events';

    if (customEvents) {
      path += '?includes=custom_events';
    }

    const { data } = await api.get(path);

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const fetchApplicationEventByName = async (event, customEvents = false) => {
  try {
    let path = `/application-events?filter[event]=${event}`;

    if (customEvents) {
      path += '&includes=custom_events';
    }

    const { data } = await api.get(path);

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default {
  fetchApplicationEvents,
  fetchApplicationEventByName,
};
